import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { uploadOptions } from "app/containers/Features/data";
import { ChevronRightIcon } from "lucide-react";
import React from "react";

interface DropdownProps {
  trigger: React.ReactNode;
  onUploadFileClick?: () => void;
}

const Index: React.FC<DropdownProps> = ({ trigger, onUploadFileClick }) => {
  const handleClick = (id: string) => {
    if (id === "upload_file") {
      onUploadFileClick?.();
    }
  };
  return (
    <>
      <DropdownMenu.Root>
        <DropdownMenu.Trigger asChild>{trigger}</DropdownMenu.Trigger>
        <DropdownMenu.Portal>
          <DropdownMenu.Content
            align="start"
            className="w-[300px] bg-white rounded-[4px] border border-[#E9ECF2] shadow-[2px_2px_6px_0px_rgba(237,239,242,0.70)] py-[10px] z-50"
            sideOffset={5}
          >
            {uploadOptions.slice(0, 4).map((ele) => {
              return (
                <DropdownMenu.Item
                  key={ele.label}
                  className="items-center flex gap-2 pl-4 pr-[8px] py-[12px] text-sm leading-[21px] mt-[2px] text-secondary outline-none cursor-pointer rounded hover:bg-[#E9ECF2] hover:rounded-none focus:bg-[#E9ECF2]"
                >
                  <button
                    className="flex gap-4"
                    onClick={() => {
                      handleClick(ele?.id);
                    }}
                  >
                    <img src={ele.icon} alt={ele.label} className="w-5" />
                    <div className="text-sm text-[#253858] font-medium line-clamp-1">
                      {ele.label}
                    </div>
                  </button>
                </DropdownMenu.Item>
              );
            })}
            <DropdownMenu.Sub>
              <DropdownMenu.SubTrigger className="group relative flex select-none items-center rounded-[3px] leading-none outline-none data-[disabled]:pointer-events-none data-[highlighted]:bg-violet9 data-[highlighted]:data-[state=open]:bg-violet9 data-[state=open]:bg-violet4 data-[disabled]:text-mauve8 data-[highlighted]:data-[state=open]:text-violet1 data-[highlighted]:text-violet1 data-[state=open]:text-violet11 items-center flex gap-2 pl-4 pr-[8px] py-[12px] text-sm leading-[21px] mt-[2px] text-secondary outline-none cursor-pointer rounded hover:bg-[#E9ECF2] hover:rounded-none focus:bg-[#E9ECF2]">
                <img
                  src={uploadOptions[4].icon}
                  alt={uploadOptions[4].label}
                  className="w-5"
                />
                <div className="text-sm text-[#253858] font-medium line-clamp-1">
                  {uploadOptions[4].label}
                </div>
                <div className="ml-auto pl-5 text-mauve11 group-data-[disabled]:text-mauve8 group-data-[highlighted]:text-white">
                  <ChevronRightIcon />
                </div>
              </DropdownMenu.SubTrigger>
              <DropdownMenu.Portal>
                <DropdownMenu.SubContent
                  className="min-w-[220px] rounded-md bg-white p-[5px] shadow-[0px_10px_38px_-10px_rgba(22,_23,_24,_0.35),_0px_10px_20px_-15px_rgba(22,_23,_24,_0.2)] will-change-[opacity,transform] data-[side=bottom]:animate-slideUpAndFade data-[side=left]:animate-slideRightAndFade data-[side=right]:animate-slideLeftAndFade data-[side=top]:animate-slideDownAndFade z-[999]"
                  sideOffset={2}
                  alignOffset={-5}
                >
                  {uploadOptions[4]?.subData?.map((ele) => {
                    return (
                      <DropdownMenu.Item
                        key={ele.label}
                        className="items-center flex gap-2 pl-4 pr-[8px] py-[12px] text-sm leading-[21px] mt-[2px] text-secondary outline-none cursor-pointer rounded hover:bg-[#E9ECF2] hover:rounded-none focus:bg-[#E9ECF2]"
                      >
                        <img src={ele.icon} alt={ele.label} className="w-5" />
                        <div className="text-sm text-[#253858] font-medium line-clamp-1">
                          {ele.label}
                        </div>
                      </DropdownMenu.Item>
                    );
                  })}
                </DropdownMenu.SubContent>
              </DropdownMenu.Portal>
            </DropdownMenu.Sub>
          </DropdownMenu.Content>
        </DropdownMenu.Portal>
      </DropdownMenu.Root>
    </>
  );
};

export default Index;
